import { render, staticRenderFns } from "./seurantajakso-form.vue?vue&type=template&id=1a8bb4ec&scoped=true&"
import script from "./seurantajakso-form.vue?vue&type=script&lang=ts&"
export * from "./seurantajakso-form.vue?vue&type=script&lang=ts&"
import style0 from "./seurantajakso-form.vue?vue&type=style&index=0&id=1a8bb4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8bb4ec",
  null
  
)

export default component.exports